
export const TRANSACTION_VOUCHER = {
  ADMIN_VOUCHER_CONNECT_REQUEST: 'ADMIN_VOUCHER_CONNECT_REQUEST',
  ADMIN_VOUCHER_CONNECT_SUCCESS: 'ADMIN_VOUCHER_CONNECT_SUCCESS',
  ADMIN_VOUCHER_CONNECT_FAIL: 'ADMIN_VOUCHER_CONNECT_FAIL'
};
